import { ListHeaderFilterInput, ListHeaderFilterContainer } from '@/components/List'

import { useTexts } from './hooks/useTexts'
import { useFilter } from './hooks/useFilter'

export function Filter() {
  const { query, setQuery, editing, noEntries } = useFilter()

  const texts = useTexts()

  const disabled = editing || noEntries

  return (
    <ListHeaderFilterContainer>
      <ListHeaderFilterInput
        disabled={disabled}
        setQuery={setQuery}
        testId="list-header-filter-input"
        placeholder={texts.filterPlaceholder}
        query={query}
      />
    </ListHeaderFilterContainer>
  )
}
